import React from 'react';

import Layout from '../Layout';
import ProtectedRoute from './ProtectedRoute';

const AuthenticatedLayout = () => (
  <ProtectedRoute>
    <Layout />
  </ProtectedRoute>
);

export default AuthenticatedLayout;
